import Axios from "axios";
import store from "@/store";
import Notify from "devextreme/ui/notify";

import { IHttpBaseResponse } from "@/core/interface/IHttpBaseResponse";
import { BaseResultStatusEnum } from "@/core/enum/BaseResultStatusEnum";

export default {
  async get(epMethod: string): Promise<IHttpBaseResponse> {
    const result = await Axios.get(
      store.getters["getUseDevCfgService"] === true
        ? store.getters["getDevCfgServiceUrl"] + epMethod
        : store.getters["getCfgServiceUrl"] + epMethod
    )
      .then((result) => {
        return this.processResultOK(result);
      })
      .catch((error) => {
        return this.processResultErr(error);
      });
    return result;
  },

  async post(epMethod: string, request: string): Promise<IHttpBaseResponse> {
    const headers = {
      "Content-Type": "application/json",
    };

    const result = await Axios.post(
      store.getters["getUseDevCfgService"] === true
        ? store.getters["getDevCfgServiceUrl"] + epMethod
        : store.getters["getCfgServiceUrl"] + epMethod,
      request,
      {
        headers: headers,
      }
    )
      .then((result) => {
        return this.processResultOK(result);
      })
      .catch((error) => {
        return this.processResultErr(error);
      });
    return result;
  },

  processResultOK(result: any): Promise<IHttpBaseResponse> {
    console.log("XXXX", result);
    if (result.data.state) {
      return Promise.resolve({
        isOk: false,
        data: null,
        message: result.data.state.msg,
        messageNumber: result.data.state.number,
        state: BaseResultStatusEnum.Error,
      });
    }
    return Promise.resolve({
      isOk: true,
      data: result.data,
      message: null,
      messageNumber: 0,
      state: BaseResultStatusEnum.OK,
    });
  },

  processResultErr(error: any): Promise<IHttpBaseResponse> {
    if (error.response === undefined) {
      return Promise.resolve(<IHttpBaseResponse>{
        isOk: false,
        data: null,
        message: "Server je nedostupný",
        messageNumber: -1,
        state: BaseResultStatusEnum.Unreachable,
      });
    }

    let stateStr = BaseResultStatusEnum.Unknown;
    let msgNumber = -1;

    switch (error.response.request.status) {
      case 401:
        stateStr = BaseResultStatusEnum.Logout;
        msgNumber = -3;
        break;
      default:
        stateStr = BaseResultStatusEnum.Error;
        msgNumber = -2;
    }

    if (error.response.data.state) {
      Notify(error.response.data.state.msg, error.response.data.state.type, 8000);
      return Promise.resolve(<IHttpBaseResponse>{
        isOk: false,
        data: null,
        message: error.response.data.state.msg,
        messageNumber: error.response.data.state.number,
        state: stateStr,
      });
    } else {
      Notify(error.response.statusText, "error", 4000);
      return Promise.resolve(<IHttpBaseResponse>{
        isOk: false,
        data: null,
        message: error.response.statusText,
        messageNumber: msgNumber,
        state: stateStr,
      });
    }
  },
};
